import { render } from "./form-popup.vue?vue&type=template&id=2fa316c4"
import script from "./form-popup.vue?vue&type=script&lang=js"
export * from "./form-popup.vue?vue&type=script&lang=js"

import "./form-popup.vue?vue&type=style&index=0&id=2fa316c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__